<template>
  <v-row no-gutters justify="center">
    <v-card style="width:100%;">
      <v-row no-gutters>
        <v-col md="12" sm="12">
          <v-card-text>
            <v-row no-gutters>
              <v-col md="7" sm="7">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title
                      class="headline"
                    >{{ $tc('dashboard.menu.eventDetails.unique_visits') }}</v-list-item-title>
                    <v-list-item-subtitle class="display-1">{{ eventOverallVisits }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="5" sm="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title
                      class="headline"
                    >{{ $tc('dashboard.menu.eventDetails.classes') }}</v-list-item-title>
                    <v-list-item-subtitle class="display-1">{{ eventClassCount }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="7" sm="7">
                <v-divider></v-divider>
              </v-col>
              <v-col md="5" sm="5">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="7" sm="7">
                <v-row>
                  <v-col md="12" sm="12">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title
                          class="headline"
                        >{{ $tc('dashboard.menu.eventDetails.mob_users') }}</v-list-item-title>
                        <v-list-item-subtitle class="display-1">{{ eventMobileVisits }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="5" sm="5">
                <v-row>
                  <v-col md="6" sm="6">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title
                          class="headline"
                        >{{ $tc('dashboard.menu.eventDetails.registrants') }}</v-list-item-title>
                        <v-list-item-subtitle class="display-1">{{ registered }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col md="6" sm="12" v-if="registered > 0">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">{{ $tc('dashboard.menu.eventDetails.total') }}</th>
                            <th class="text-left">{{ $tc('dashboard.menu.eventDetails.status') }}</th>
                          </tr>
                        </thead>
                        <tbody style="text-align: left;">
                          <tr v-for="(item,i) in eventRegistrants" :key="i">
                            <td v-if="item.total > 0" style="font-size:12px;">{{ item.total }}</td>
                            <td v-if="item.total > 0" style="font-size:12px;">{{ item.status }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="7" sm="7">
                <v-divider></v-divider>
              </v-col>
              <v-col md="5" sm="5">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="7" sm="7">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title
                      class="headline"
                    >{{ $tc('dashboard.menu.eventDetails.pc_users') }}</v-list-item-title>
                    <v-list-item-subtitle class="display-1">{{ eventPCVisits }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="5" sm="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title
                      class="headline"
                    >{{ $tc('dashboard.menu.eventDetails.wait_list') }}</v-list-item-title>
                    <v-list-item-subtitle class="display-1">{{ waitListCount }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>
<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import Vue from "vue";
import AsyncComputed from "vue-async-computed";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  props: ['response'],
  data() {
    return {
      eventOverallVisits: null,
      eventMobileVisits: null,
      eventPCVisits: null,
      eventClassCount: null,
      eventRegistrants: [],
      registered: null,
      waitListCount: null
    };
  },
  asyncComputed: {
    eventOverallVisits: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getEventOverallVisits/" +
          this.$route.params.id
      );

      return response.message;
    },
    eventMobileVisits: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getEventMobileVisits/" +
          this.$route.params.id
      );

      return response.message;
    },
    eventPCVisits: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getEventPCVisits/" +
          this.$route.params.id
      );

      return response.message;
    },
    eventClassCount: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getClassCount/" +
          this.$route.params.id
      );

      return response.message;
    },
    eventRegistrants: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getEventRegistrants/" +
          this.$route.params.id
      );
      var items = [];

      if (response.success == 1) {
        this.registered = response.message[0].registered;
        items = [
          {
            status: this.$t("dashboard.menu.eventDetails.canceled"),
            total: response.message[0].canceled
          },
          {
            status: this.$t("dashboard.menu.eventDetails.completed"),
            total: response.message[0].completed
          },
          {
            status: this.$t("dashboard.menu.eventDetails.empty"),
            total: response.message[0].unknown
          },
          {
            status: this.$t("dashboard.menu.eventDetails.inpayment"),
            total: response.message[0].payment
          },
          {
            status: this.$t("dashboard.menu.eventDetails.added"),
            total: response.message[0].added
          },
          {
            status: this.$t("dashboard.menu.eventDetails.failed"),
            total: response.message[0].failed
          },
          {
            status: this.$t("dashboard.menu.eventDetails.deleted"),
            total: response.message[0].deleted
          }
        ];
      }
      return items;
    },
    waitListCount: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getWaitListCount/" +
          this.$route.params.id
      );

      return response.message;
    }
  }
};
</script>
